<template>
    <div class="global-roomdesigner-selection">
        <global-modal v-if="showModal" @close="cancel">
            <template slot="header">
                <h2>{{ $t('roomdesigner.headline') }}</h2>
            </template>
            <template slot="body">
                <div class="row">
                    <div class="col-12">
                        <div class="row" v-if="reference">
                            <strong class="col-12">1 {{ $t('roomdesigner.decor') }}</strong>
                            <div class="col-4 col-md-2 col-xl-1 decor__col"
                                 :class="[decorSelected(reference.title) ? 'decor__col--selected':'']"
                                 @click="toggleSelection(reference.title)">
                                <div class="decor__col--icon icon-item icon-item--ghost">
                                    <span class="icon" :class="[decorSelected(reference.title) ? 'icon--check-square':'icon--square']"/>
                                </div>
                                <global-material-tile :disable-link="true" :entity="reference" />
                            </div>
                        </div>
                        <div class="row" v-if="data.length">
                            <strong class="col-12">{{ data.length }} {{ decorsLabel }}</strong>
                            <div v-for="(decor, index) in data"
                                 class="col-4 col-md-2 col-xl-1 decor__col"
                                 :class="['group--' + groupTiles(index), decorSelected(decor.title) ? 'decor__col--selected':'']"
                                 v-show="page === groupTiles(index) || tilesPerPage === null"
                                 @click="toggleSelection(decor.title)"
                            >
                                <div class="decor__col--icon icon-item icon-item--ghost">
                                    <span class="icon" :class="[decorSelected(decor.title) ? 'icon--check-square':'icon--square']"/>
                                </div>
                                <global-material-tile :disable-link="true" :entity="decor" />
                            </div>
                        </div>
                        <div class="row" v-if="reference && data.length">
                            <global-input-checkbox class="selectAll" :label="$t('roomdesigner.selectAll')" :value="allDecorsSelected" @input="toggleAll" />
                        </div>
                    </div>
                </div>

            </template>

            <template slot="pagination" v-if="showPagination">
                <span class="pagination__indicator">{{ decorsShown }}</span>
                <global-button icon="arrow-left" @click="changePage(page-1)" theme="secondary"
                               :class="page-1 < lowerEnd ? 'disabled': ''" class="ignore-context pagination--prev"/>
                <global-button icon="arrow-right" @click="changePage(page+1)" theme="secondary"
                               :class="page+1 > upperEnd ? 'disabled': ''" class="ignore-context pagination--prev"/>
            </template>

            <global-button slot="controls__left" @click="cancel">{{ $t('roomdesigner.cancel') }}</global-button>
            <global-button slot="controls__right" :disabled="selectedDecors.length === 0" :href="openRoomdesigner" target="_blank" @click="select">{{ $t('roomdesigner.select') }}</global-button>
        </global-modal>
    </div>
</template>

<script>
import GlobalModal from "@global/global-elements/global-modal/global-modal";
import GlobalMaterialTile from "@global/global-elements/global-material-tile/global-material-tile.vue";
import {detectBreakpoint} from "@utilities/sal-breakpoint/sal-breakpoint";
import GlobalButton from "@global/global-elements/global-button/global-button";
import GlobalInputCheckbox from "@global/global-elements/global-input-checkbox/global-input-checkbox";
import {globalRoomdesignerUtilities} from "@global/global-elements/global-roomdesigner/global-roomdesigner-utilities";
import {track_abstract, tracking_events} from '../../../utilities/track-abstract/track-abstract';

const tilesPerPageConfiguration = {
    'xs': null,
    'sm': null,
    'md': 12,
    'lg': 12,
    'xl': 24
}

export default {
    name: "global-roomdesigner-selection",
    props: {
        initialData: {},
    },
    data() {
        return {
            reference: null,
            data: null,
            selectedDecors: [],
            decorsLabel: this.$t('roomdesigner.decorLabel'),
            page: 0,
            tilesPerPage: 12,
            ignoreNextInputEvent: false
        }
    },
    watch: {
        initialData: function () {
            this.selectRoomdesigner(this.initialData)
        }
    },
    computed: {
        showModal() {
            return this.reference || this.data
        },
        upperEnd() {
            return (this.data && this.tilesPerPage > 0) ? Math.ceil(this.data.length / this.tilesPerPage) - 1 : 0;
        },
        lowerEnd() {
            return 0
        },
        decorsShown() {
            return this.page * this.tilesPerPage + 1 + ' - ' + (((this.page * this.tilesPerPage + this.tilesPerPage) > this.data.length) ? this.data.length : this.page * this.tilesPerPage + this.tilesPerPage);
        },
        allDecorsSelected() {
            return this.selectedDecors.length === this.data.length + 1;
        },
        showPagination() {
            return this.tilesPerPage < this.data.length || false
        },
        openRoomdesigner() {
            return this.selectedDecors.length ? globalRoomdesignerUtilities.getUrl() + this.selectedDecors.join(','): '#';
        }
    },
    methods: {
        selectRoomdesigner(initialData) {
            if (initialData.reference) {
                this.reference = initialData.reference;
            }

            if (initialData.data) {
                this.data = initialData.data;
            }

            if (initialData.selectedDecors) {
                this.selectedDecors = initialData.selectedDecors;
            }

            if (initialData.decorsLabel) {
                this.decorsLabel = initialData.decorsLabel;
            }
        },
        groupTiles(index) {
            return Math.floor(index / this.tilesPerPage)
        },
        changePage(index) {
            let normalizedPage = index < this.lowerEnd ? this.lowerEnd : index;
            normalizedPage = index > this.upperEnd ? this.upperEnd : normalizedPage;
            this.page = normalizedPage;
        },
        toggleSelection(decorName) {
            const decorIndex = this.selectedDecors.indexOf(decorName);
            this.ignoreNextInputEvent = true;
            if (decorIndex !== -1) {
                this.selectedDecors.splice(decorIndex, 1)
            } else {
                this.selectedDecors.push(decorName)
            }
        },
        toggleAll(value) {
            if (value) {
                const allDecors = [this.reference, ...this.data];
                const allDecorTitles = [];
                allDecors.forEach(decor => {
                    allDecorTitles.push(decor.title)
                })
                this.selectedDecors = [...allDecorTitles];
                this.ignoreNextInputEvent = false;
            } else {
                if (this.ignoreNextInputEvent) {
                    this.ignoreNextInputEvent = false;
                    return
                }
                this.selectedDecors = []
            }
        },
        decorSelected(decorName) {
            return this.selectedDecors.indexOf(decorName) !== -1
        },
        clearData() {
            this.reference = null;
            this.data = null;
            this.selectedDecors = [];
        },
        cancel() {
            this.clearData();
            this.$emit('done')
        },
        select() {
            this.clearData();
            this.$emit('done')
            track_abstract.trigger_event(tracking_events.RoomDesignerOpen, this.selectedDecors.join(','));
        }
    },
    mounted() {
        this.tilesPerPage = tilesPerPageConfiguration[detectBreakpoint()] ? tilesPerPageConfiguration[detectBreakpoint()] : 100
        window.addEventListener('resize', () => {
            const oldTilePage = this.tilesPerPage;

            this.tilesPerPage = tilesPerPageConfiguration[detectBreakpoint()] ? tilesPerPageConfiguration[detectBreakpoint()] : this.data?.length || 100
            this.changePage(Math.floor(this.page * oldTilePage / this.tilesPerPage));
        });

        if (!this.initialData) {
            document.addEventListener('selectRoomdesigner', (e) => {
                if (e.detail) {
                    this.selectRoomdesigner(e.detail);
                }
            })
        }
    },
    components: {GlobalInputCheckbox, GlobalButton, GlobalMaterialTile, GlobalModal}
}
</script>

